import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Text from './components/Text';
import Button from './components/Button';
import { Section, Grid, GridColumn, Container, Box, Video } from '@miro-site/core';
import { LazyImageAdapter } from '@miro-site/components_utils';
import styled, { useTheme } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ImageNormalStyles = {
  overflow: 'hidden'
};
var VideoNormalStyles = {
  overflow: 'hidden'
};
var VideoBg = styled.div.withConfig({
  displayName: "SuperComponent__VideoBg",
  componentId: "sc-s0qv15-0"
})(["position:absolute;max-width:100%;max-height:100%;height:100%;width:100%;top:0;left:0;z-index:-100;overflow:hidden;"]);

var SuperComponent = function SuperComponent(_ref) {
  var _background$mobileIma, _background$mobileIma2, _background$desktopIm, _background$desktopIm2;

  var layout = _ref.layout,
      headline = _ref.headline,
      subtitle = _ref.subtitle,
      button = _ref.button,
      additionalButton = _ref.additionalButton,
      image = _ref.image,
      video = _ref.video,
      _ref$background = _ref.background,
      background = _ref$background === void 0 ? {} : _ref$background,
      _ref$spaces = _ref.spaces,
      spaces = _ref$spaces === void 0 ? {} : _ref$spaces;
  var theme = useTheme();
  var colors = theme.colors;

  var getPaddingValue = function getPaddingValue(padding) {
    return theme.spaces[padding] || padding;
  };

  var maxWidth = layout.maxWidth == 'article' ? [null, 720] : layout.maxWidth;
  var mx = layout.maxWidth == 'article' || background.videoId ? [null, 'auto'] : undefined;
  var styles = {
    backgroundColor: colors[background.color] || background.color,
    backgroundSize: background.size,
    backgroundPosition: background.position,
    backgroundImage: [((_background$mobileIma = background.mobileImage) === null || _background$mobileIma === void 0 ? void 0 : _background$mobileIma.src) && "url(\"".concat((_background$mobileIma2 = background.mobileImage) === null || _background$mobileIma2 === void 0 ? void 0 : _background$mobileIma2.src, "\")"), ((_background$desktopIm = background.desktopImage) === null || _background$desktopIm === void 0 ? void 0 : _background$desktopIm.src) && "url(\"".concat((_background$desktopIm2 = background.desktopImage) === null || _background$desktopIm2 === void 0 ? void 0 : _background$desktopIm2.src, "\")")],
    paddingTop: [getPaddingValue(spaces.mobileTopPadding), getPaddingValue(spaces.desktopTopPadding)],
    paddingBottom: [getPaddingValue(spaces.mobileBottomPadding), getPaddingValue(spaces.desktopBottomPadding)],
    maxWidth: maxWidth,
    width: layout === null || layout === void 0 ? void 0 : layout.width,
    height: layout === null || layout === void 0 ? void 0 : layout.height
  };

  if (background.videoId) {
    Object.assign(styles, {
      position: 'relative'
    });
  }

  var GAP_FOR_ONE_COLUMN = 88;
  return /*#__PURE__*/_jsxs(Section, {
    $withLastChildPadding: false,
    $mx: mx,
    $styles: styles,
    children: [background.videoId && /*#__PURE__*/_jsx(VideoBg, {
      children: /*#__PURE__*/_jsx(Video, {
        id: background.videoId,
        options: {
          playlistLoop: true,
          fitStrategy: 'fill'
        }
      })
    }), /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Grid, {
        columns: layout.columns,
        isRtl: layout.textPosition == 'right',
        align: "center",
        children: [/*#__PURE__*/_jsxs(GridColumn, {
          $styles: {
            textAlign: layout.contentAlignment
          },
          $mr: layout.columns == 1 ? undefined : 110,
          $mb: layout.columns == 1 ? GAP_FOR_ONE_COLUMN : [GAP_FOR_ONE_COLUMN, null],
          children: [headline && /*#__PURE__*/_jsx(Box, {
            $mb: theme.spaces.md,
            children: /*#__PURE__*/_jsx(Text, _objectSpread({}, headline))
          }), subtitle && /*#__PURE__*/_jsx(Box, {
            $mb: theme.spaces.md * 2,
            children: /*#__PURE__*/_jsx(Text, _objectSpread({}, subtitle))
          }), button && /*#__PURE__*/_jsx(Button, _objectSpread({}, button)), additionalButton && /*#__PURE__*/_jsx(Button, _objectSpread({}, additionalButton))]
        }), (image || video) && /*#__PURE__*/_jsxs(GridColumn, {
          children: [image && /*#__PURE__*/_jsx(Box, {
            $styles: ImageNormalStyles,
            children: /*#__PURE__*/_jsx(LazyImageAdapter, {
              assets: image
            })
          }), (video === null || video === void 0 ? void 0 : video.id) && /*#__PURE__*/_jsx(Box, {
            $styles: VideoNormalStyles,
            children: /*#__PURE__*/_jsx(Video, {
              id: video.id,
              thumbnail: video.thumbnail
            })
          })]
        })]
      })
    })]
  });
};

export default SuperComponent;